// ============================================================================
// OBT F3-D — Kurumsal hafıza enum etiketleri (KAYNAK: backend enums.py)
// ============================================================================
// Burada yeni değer türetilmez; yalnız backend'de GERÇEKTEN var olan
// AssetType / AssetEventType / WarrantyStatus değerleri Türkçeleştirilir.

export const ASSET_TYPE_LABELS = Object.freeze({
  child_playground: 'Çocuk oyun grubu',
  sports_equipment: 'Spor aletleri',
  basketball_court: 'Basketbol sahası',
  football_field: 'Futbol sahası',
  pool: 'Havuz',
  irrigation: 'Sulama sistemi',
  lighting: 'Aydınlatma',
  camera: 'Kameralar',
  pergola: 'Pergola',
  bench: 'Bank',
  trash_bin: 'Çöp kovası',
  picnic_table: 'Piknik masası',
  stream_gravel: 'Dere çakılı',
  other: 'Diğer',
});

export const ASSET_TYPE_CHOICES = Object.freeze(
  Object.entries(ASSET_TYPE_LABELS).map(([value, label]) => ({ value, label }))
);

export const ASSET_EVENT_LABELS = Object.freeze({
  installation: 'Yapım / kurulum',
  replacement: 'Değişim',
  maintenance: 'Bakım',
  other: 'Diğer',
});

export const ASSET_EVENT_CHOICES = Object.freeze(
  Object.entries(ASSET_EVENT_LABELS).map(([value, label]) => ({ value, label }))
);

export const WARRANTY_STATUS_LABELS = Object.freeze({
  active: 'Devam ediyor',
  expired: 'Süresi doldu',
  unknown: 'Bilinmiyor',
});

/** Garanti durumu görsel tonu (renk tek başına anlam taşımaz; metin de gösterilir). */
export const WARRANTY_STATUS_TONES = Object.freeze({
  active: 'success',
  expired: 'danger',
  unknown: 'neutral',
});

const UNKNOWN = 'Bilinmeyen';

export function memoryLabel(map, value, fallback = UNKNOWN) {
  if (value === null || value === undefined || value === '') return fallback;
  return map[value] || String(value);
}
